var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "h-12 w-12",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M76.999,40.001c0,17.44-12.02,31.86-27.97,35.89c-2.9,0.72-5.92,1.11-9.03,1.11 c-3.08,0-6.09-0.38-8.97-1.1c-15.98-4-28.03-18.44-28.03-35.9c0-20.6,16.4-37,37-37C60.599,3.001,76.999,19.401,76.999,40.001z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.999,
    cy: 40.001,
    r: 37,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.029,38.521c0,4.49-2.32,10.73-6.13,13.83c-3.08,2.51-7.15,3.3-11.75,3.55 c1.73,1.05,2.88,2.95,2.88,5.12v14.87c-2.9,0.72-5.92,1.11-9.03,1.11c-3.08,0-6.09-0.38-8.97-1.1v-9.77 c-1.25,0.39-2.89,0.62-5,0.51c-7-0.37-8-4.62-9.12-7.62c-1.13-3-4.63-3.38-4.13-4.62c2.416-0.829,4.314-0.039,5.597,0.938 c1.018,0.776,1.728,1.871,2.203,3.06c0.543,1.358,1.986,3.622,5.57,3.622c2.53,0,4.03-0.59,4.89-1.17 c0.05-2.12,1.21-3.96,2.91-4.97c-4.88-0.31-9.16-1.23-12.31-3.97c-3.5-3.04-5.61-9.11-5.61-13.39c0-3.57,1.47-7.97,3.99-10.74 c0.08-0.08,0.15-0.17,0.25-0.25c-0.58-1.74-1.25-5.18,0.38-9.39c4.85-0.09,8.68,2.56,10.24,3.84c2.82-0.65,5.9-0.96,9.14-0.96 c3.32,0,6.49,0.29,9.36,0.96c1.56-1.28,5.4-3.93,10.24-3.83c1.7,4.38,0.91,7.93,0.32,9.59 C62.529,30.711,64.029,34.921,64.029,38.521z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M39.999,3.001c-20.6,0-37,16.4-37,37s16.78,37,37,37s37-16.4,37-37S60.599,3.001,39.999,3.001z M39.999,76.001c-19.85,0-36-16.15-36-36c0-9.7,3.72-18.76,10.48-25.52c6.76-6.76,15.83-10.48,25.52-10.48 c9.7,0,18.76,3.72,25.52,10.48c6.76,6.76,10.48,15.82,10.48,25.52C75.999,59.851,59.849,76.001,39.999,76.001z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.6b619bcabe291fc3499c5a8527725f44.svg";
export { ForwardRef as ReactComponent };